import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, EMPTY_STRING, LoadingMessages } from "src/app/common/Const";
import { MI200002, MQ200003 } from "src/app/common/const-message-id";
import { GC_D2083_OUT_APPROVED } from "src/app/common/ConstCcd";
import { TableColumnDef } from "src/app/common/table-column-def";
import { ReqAccess } from "src/app/request/req-access";
import { ReqSpmt10271Confirm, Spmt10271ConfirmRowDto } from "src/app/request/req-spmt10271-confirm";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";
import { NotificationDialogComponent } from "../notification-dialog/notification-dialog.component";

export enum ColumnIds {
  SlipNo = "slipNo",
  InStoreCd = "inStoreCd",
  InStoreNm = "inStoreNm",
  SlipTypeNm = "slipTypeNm",
  OutDate = "outDate",
  ReqStatusNm = "reqStatusNm",
  RedBlackNm = "redBlackNm",
  SlipCancelNm = "slipCancelNm",
  OutStockQtyTotal = "outStockQtyTotal",
  OutCostAmtExcTotal = "outCostAmtExcTotal",
  OutSellPriceAmtExcTotal = "outSellPriceAmtExcTotal",
  SlipCreateDate = "slipCreateDate",
  OutSlipApproveDate = "outSlipApproveDate",
  InSlipApproveDate = "inSlipApproveDate",
  SlipChangeDate = "slipChangeDate",
  SlipCancelDate = "slipCancelDate",
  OutRequesterNm = "outRequesterNm",
  OutApproverNm = "outApproverNm",
  InApproverNm = "inApproverNm",
  OutSlipComment = "outSlipComment",
  OutSlipApproverComment = "outSlipApproverComment",
  InSlipApproverComment = "inSlipApproverComment",
}

export enum ColumnHeaders {
  SlipNo = "伝票番号",
  InStoreCd = "入庫店コード",
  InStoreNm = "入庫店名称",
  SlipTypeNm = "店間移動伝票区分",
  OutDate = "出庫日",
  ReqStatusNm = "申請状態",
  RedBlackNm = "赤黒区分",
  SlipCancelNm = "伝票取消フラグ",
  OutStockQtyTotal = "出庫数量合計",
  OutCostAmtExcTotal = "出庫原価金額合計(抜)",
  OutSellPriceAmtExcTotal = "出庫売価金額合計(抜)",
  SlipCreateDate = "伝票登録日",
  OutSlipApproveDate = "伝票承認日(出庫)",
  InSlipApproveDate = "伝票承認日(入庫)",
  SlipChangeDate = "伝票訂正日",
  SlipCancelDate = "伝票取消日",
  OutRequesterNm = "出庫申請者",
  OutApproverNm = "出庫承認者",
  InApproverNm = "入庫承認者",
  OutSlipComment = "出庫申請者コメント",
  OutSlipApproverComment = "出庫承認者コメント",
  InSlipApproverComment = "入庫承認者コメント",
}

interface TableRow extends Spmt10271ConfirmRowDto {
  form: {
    outSlipApproverCommentFormCtrl: FormControl;
  };
}

@Component({
  selector: "spmt10271-confirm-dialog",
  templateUrl: "./spmt10271-confirm-dialog.component.html",
  styleUrls: ["./spmt10271-confirm-dialog.component.css"],
})
export class Spmt10271ConfirmDialogComponent implements OnInit, AfterViewInit {
  columnIds: string[] = [
    ColumnIds.SlipNo,
    ColumnIds.InStoreCd,
    ColumnIds.InStoreNm,
    ColumnIds.SlipTypeNm,
    ColumnIds.OutDate,
    ColumnIds.ReqStatusNm,
    ColumnIds.RedBlackNm,
    ColumnIds.SlipCancelNm,
    ColumnIds.OutStockQtyTotal,
    ColumnIds.OutCostAmtExcTotal,
    ColumnIds.OutSellPriceAmtExcTotal,
    ColumnIds.SlipCreateDate,
    ColumnIds.OutSlipApproveDate,
    ColumnIds.InSlipApproveDate,
    ColumnIds.SlipChangeDate,
    ColumnIds.SlipCancelDate,
    ColumnIds.OutRequesterNm,
    ColumnIds.OutApproverNm,
    ColumnIds.InApproverNm,
    ColumnIds.OutSlipComment,
    ColumnIds.OutSlipApproverComment,
    ColumnIds.InSlipApproverComment,
  ];

  columnDefs: TableColumnDef[] = [
    { columnId: ColumnIds.SlipNo, header: ColumnHeaders.SlipNo, width: 90, align: Alginment.Left, editable: true },
    { columnId: ColumnIds.InStoreCd, header: ColumnHeaders.InStoreCd, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.InStoreNm, header: ColumnHeaders.InStoreNm, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.SlipTypeNm, header: ColumnHeaders.SlipTypeNm, width: 115, align: Alginment.Left },
    { columnId: ColumnIds.OutDate, header: ColumnHeaders.OutDate, width: 85, align: Alginment.Left },
    { columnId: ColumnIds.ReqStatusNm, header: ColumnHeaders.ReqStatusNm, width: 85, align: Alginment.Left },
    { columnId: ColumnIds.RedBlackNm, header: ColumnHeaders.RedBlackNm, width: 70, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelNm, header: ColumnHeaders.SlipCancelNm, width: 105, align: Alginment.Left },
    { columnId: ColumnIds.OutStockQtyTotal, header: ColumnHeaders.OutStockQtyTotal, width: 90, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.OutCostAmtExcTotal, header: ColumnHeaders.OutCostAmtExcTotal, width: 145, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.OutSellPriceAmtExcTotal, header: ColumnHeaders.OutSellPriceAmtExcTotal, width: 145, align: Alginment.Right, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SlipCreateDate, header: ColumnHeaders.SlipCreateDate, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.OutSlipApproveDate, header: ColumnHeaders.OutSlipApproveDate, width: 120, align: Alginment.Left },
    { columnId: ColumnIds.InSlipApproveDate, header: ColumnHeaders.InSlipApproveDate, width: 120, align: Alginment.Left },
    { columnId: ColumnIds.SlipChangeDate, header: ColumnHeaders.SlipChangeDate, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.SlipCancelDate, header: ColumnHeaders.SlipCancelDate, width: 90, align: Alginment.Left },
    { columnId: ColumnIds.OutRequesterNm, header: ColumnHeaders.OutRequesterNm, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.OutApproverNm, header: ColumnHeaders.OutApproverNm, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.InApproverNm, header: ColumnHeaders.InApproverNm, width: 110, align: Alginment.Left },
    { columnId: ColumnIds.OutSlipComment, header: ColumnHeaders.OutSlipComment, width: 190, align: Alginment.Left },
    { columnId: ColumnIds.OutSlipApproverComment, header: ColumnHeaders.OutSlipApproverComment, width: 190, align: Alginment.Left, isTextbox: true },
    { columnId: ColumnIds.InSlipApproverComment, header: ColumnHeaders.InSlipApproverComment, width: 190, align: Alginment.Left },
  ];

  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource<TableRow>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  title: string = "";
  public itemTableWidth: any;
  constructor(
    public dialogRef: MatDialogRef<Spmt10271ConfirmDialogComponent>,

    public httpBasic: HttpBasicService,
    @Inject(MAT_DIALOG_DATA) public data: { rows: Spmt10271ConfirmRowDto[]; confirmKbn: string; access: ReqAccess },
    private readonly message: MessageService,
    public commonService: CommonService
  ) {
    this.title = this.data.confirmKbn === GC_D2083_OUT_APPROVED ? "店間移動出庫承認" : "店間移動出庫却下";
  }

  ngOnInit() {
    this.calcTableWidth();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.data = this.data.rows.map((item) => ({ ...item, form: { outSlipApproverCommentFormCtrl: new FormControl(item.outSlipApproverComment ?? EMPTY_STRING) } }));
  }

  calcTableWidth() {
    this.itemTableWidth = { width: "100%" };
  }

  btnConfirmClick() {
    this.commonService.openYesNoDialog(this.title, this.message.message[MQ200003]).subscribe((data) => {
      if (data) this.fnConfirm();
    });
  }

  fnConfirm() {
    this.httpBasic.beforeRequestStart(LoadingMessages.Registing);
    const request: ReqSpmt10271Confirm = {
      rows: this.dataSource.data.map((item) => ({ ...item, outSlipApproverComment: item.form.outSlipApproverCommentFormCtrl.value, form: undefined })),
      access: this.data.access,
      confirmKbn: this.data.confirmKbn,
    };
    this.httpBasic.spmt10271Confirm(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        const dialogRef = this.commonService.dialog.open(NotificationDialogComponent, {
          data: { title: this.title, message: this.message.message[MI200002] },
        });
        dialogRef.afterClosed().subscribe(() => {
          this.dialogRef.close({ isClose: true });
        });
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  get GC_D2083_OUT_APPROVED() {
    return GC_D2083_OUT_APPROVED;
  }
}
